import { render } from "./FilterTalepSvg.vue?vue&type=template&id=0078596e"
import script from "./FilterTalepSvg.vue?vue&type=script&lang=js"
export * from "./FilterTalepSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__